/** @jsxImportSource solid-js */
import { createSignal, createUniqueId, type JSX } from "solid-js";
import { useDebounce } from "../debounce.solid";
import { Icons } from "../icons.solid";
import { TooltipBase } from "../tooltip.solid";

export function createTextInput({
  initial = "",
  label = "",
  kind = "text",
  placeholder = "",
  icon = null as JSX.Element,
  tooltip = null as JSX.Element,
}) {
  const id = createUniqueId();
  const [actualKind, setKind] = createSignal(kind);
  const [value, setValue] = createSignal(initial);
  const debounced = useDebounce(setValue, 500);
  const [actualIcon, setIcon] = createSignal(icon);
  const [disabled, setDisabled] = createSignal(false);

  return {
    component: (
      <div class="mt-4">
        <div class="my-1">
          <label for={id} class="font-bold">
            {label}
          </label>
          {tooltip && (
            <span class="relative group/tooltip ml-2">
              <Icons.CircleInfo />
              <TooltipBase>{tooltip}</TooltipBase>
            </span>
          )}
        </div>
        <div class="relative">
          <input
            class="block w-full px-4 py-2 text-brand-900 placeholder-brand-300 bg-white border rounded-lg focus:border-brand-500 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-brand-300 disabled:bg-gray/20"
            type={actualKind()}
            id={id}
            autocomplete="off"
            placeholder={placeholder}
            aria-label={label}
            value={value()}
            disabled={disabled()}
            onInput={(e) => {
              debounced(e.target.value);
            }}
          />
          <div class="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-brand-500 rounded-e-md focus:outline-none focus:text-primary-900 border-0">
            {actualIcon()}
          </div>
        </div>
      </div>
    ),
    value: value,
    reset: () => {
      setValue("");
    },
    setKind: setKind,
    setIcon: setIcon,
    id: id,
    disable: (n: boolean) => {
      if (n) {
        setValue("");
      }
      setDisabled(n);
    },
  };
}
